const gameChoices = [
  // { id: 'minecraft', name: 'Minecraft' },
  { id: 'valheim', name: 'Valheim' },
];

export default gameChoices;
